import PreferencesPane from 'src/components/PreferencesPane';
import Footer from './Footer';
import Navigation from './Navigation';
import React, { useState } from 'react';
import ExploreModal from './ExploreModal';
import { AppRoutes } from './Routes';
import { Providers } from './providers';
import { WelcomeGruModal } from './WelcomeGruModal';
import { PreferencesModal } from './PreferencesModal';
import ErrorBoundaryWrapper from './ErrorBoundaryWrapper';
import ContentPolicyModal from './ContentPolicyModal';

const App = () => {
    const [exploreModalOpen, setExploreModalOpen] = useState(false);
    const [preferencesOpen, setPreferencesOpen] = useState(false);

    return (
        <ErrorBoundaryWrapper>
            <Providers setPreferencesOpen={setPreferencesOpen}>
                <Navigation
                    setPreferencesOpen={setPreferencesOpen}
                    setExploreModalOpen={setExploreModalOpen}
                />
                <PreferencesPane preferencesOpen={preferencesOpen} />
                <ExploreModal
                    setExploreModalOpen={setExploreModalOpen}
                    exploreModalOpen={exploreModalOpen}
                />
                <PreferencesModal
                    setUserPreferencesPaneOpen={setPreferencesOpen}
                />
                <WelcomeGruModal />
                <ContentPolicyModal />
                <AppRoutes setExploreModalOpen={setExploreModalOpen} />
                <Footer />
            </Providers>
        </ErrorBoundaryWrapper>
    );
};

export default App;
